import React, { useEffect, useRef, useState } from 'react';
import './ModalForm.scss';
import './ModalForm-media.scss';
import { MediaContent, ValidationFormItems, bodyAuto, bodyHidden } from '../../services/GlobalFunctions';
import Input from '../Input/Input';
import InputPhone from '../Input/InputPhone';
import Button from '../Button/Button';
import ErrorText from '../ErrorText/ErrorText';
import { ServiceData } from '../../redux/services/ServiceRedux';
import { Props } from './interfaces';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { EnumUrlsPages } from '../../services/Enum';
import Textarea from '../Textarea/Textarea';
import { CSSTransition } from 'react-transition-group';
import {content} from "../../services/content";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";


const ModalForm = ({
  title,
  buttonText,
  image,
  closedModal,
  textarea = false,
  id,
  blockedSend,
  blockedSendLoaded,
  eventMetrika,
  sendAmoCRM = false,
  hasCssTransition = false,
  showForm = false,
  recaptchaV2ref,
  contactForms
}: Props) => {
  useEffect(() => {
    if (showForm) {
      bodyHidden();
      return;
    }
    bodyAuto();
  }, [showForm]);

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+7');
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [serverText, setServerText] = useState<string | null>(null);
  const [successShow, setSuccessShow] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const success = () => {
    setName('');
    setPhone('');
    setMsg('');
    setSuccessShow(true);
    setDisableBtn(false);
  };

  const [msg, setMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const { executeRecaptcha } = useGoogleReCaptcha(); // v3

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    setDisableBtn(true);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    let token = '';
    if (!executeRecaptcha) {
      console.debug('recaptcha not set, ignoring');
    } else {
      token = await executeRecaptcha(); // v3
    }

    if (textarea) {
      if (
        !ValidationFormItems({
          fields: [msg],
          arrSetError: [setErrorMsg],
          phone,
          setErrorPhone,
        })
      ) {
        setDisableBtn(false);
        return;
      }
      ServiceData.sendEmailContacts({
        data: { name, phone, department: 0, orderNumber: '-', msg },
        token,
        setServerText,
        success,
        blockedSendLoaded,
        eventMetrika,
        contactFormId: contactForms.modal_contact_form_id
      });
    } else {
      if (!ValidationFormItems({ phone, setErrorPhone })) {
        setDisableBtn(false);
        return;
      }
      ServiceData.submitForm({
        data: { name, phone },
        setServerText,
        success,
        token,
        blockedSendLoaded,
        eventMetrika,
        contactFormId: contactForms.modal_contact_form_id
      });
    }
  };

  const nodeRef = useRef(null);
  const form = (
    <div className="modal-container">
      {successShow ? (
        <div className="modal-success">
          <div className="modal-success__close" onClick={closedModal}></div>
          <h2 className="modal-success__text">{content.modalForm.successText}</h2>
          <p className="body1">{content.modalForm.successText2}</p>
        </div>
      ) : (
        <div ref={nodeRef} className="modal-form">
          <div className="modal-form__close" onClick={closedModal}></div>
          {MediaContent(
            <div
              className={`modal-form__image`}
              style={image ? { backgroundImage: `url(${image})` } : {}}
            ></div>,
            null
          )}
          <span></span>
          <form id={id || ''} className="modal-form__form" onSubmit={handleReCaptchaVerify}>
            <h2 className="modal-form__title">{title}</h2>
            <Input
              label={content.formContacts.inputName}
              name="name"
              value={name}
              focus
              onChange={(e: any) => setName(e.target.value)}
              error={null}
              marginTop={40}
            />
            <InputPhone
              label={content.formContacts.inputPhone}
              name="phone"
              value={phone}
              onChange={(e: any) => setPhone(e.target.value)}
              error={errorPhone}
            />

            {textarea ? (
              <Textarea
                label={content.formContacts.inputMessage}
                value={msg}
                onChange={(e: any) => setMsg(e.target.value)}
                error={errorMsg}
              />
            ) : null}

            <div className="modal-form__button">
              <Button text={buttonText} widthAll disabled={disableBtn} showBlockedError={showBlockedError} />
              {serverText ? ErrorText(serverText) : null}
            </div>
            <p className="modal-form__agreement">
              {content.formContacts.text1}
              <a href={EnumUrlsPages.policy}>{content.formContacts.privacyPolicy}</a>
              {content.formContacts.text2}
            </p>
          </form>
        </div>
      )}
      <div className="modal-bg" onClick={closedModal}></div>
    </div>
  );

  return hasCssTransition ? (
    <CSSTransition
      in={showForm}
      nodeRef={nodeRef}
      timeout={{ appear: 200, enter: 0, exit: 200 }}
      classNames="css-transition-modal"
      unmountOnExit
    >
      {form}
    </CSSTransition>
  ) : showForm ? (
    form
  ) : null;
};

// Custom mergeProps to let ownProps override stateProps (fixes contactForms being overwritten by Redux defaults)
const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default WithStore()(connect(MapStateToProps, MapDispatchToProps, mergeProps)(ModalForm));
